<template>
  <v-row justify="center">
    <v-dialog
      :value="value"
      max-width="460"
      @input="$emit('input', $event)"
    >
      <v-card>
        <v-card-title>
          <span>
            {{ actionTitle }}
            <strong>{{ name }}</strong
            >?
          </span>
        </v-card-title>
        <v-card-text class="black--text">
          <span v-if="!$slots.default">
            This action cannot be reversed and your review will no
            longer be accessible.
          </span>
          <slot></slot>
        </v-card-text>
        <v-card-actions class="pb-3 pr-3">
          <v-spacer />
          <action-button
            data-testid="cancel-button"
            class="mr-2"
            @click="onCancel"
          >
            Cancel
          </action-button>
          <action-button
            data-testid="confirm-button"
            :color="actionColor"
            :disabled="disabled"
            @click="onConfirm"
          >
            <v-icon left class="material-icons-outlined">
              {{ actionIcon }}
            </v-icon>
            {{ actionTitle }}
          </action-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
export default {
  name: 'ConfirmationDialog',
  components: { ActionButton },
  props: {
    value: {
      type: [String, Boolean],
      default: false,
    },
    actionColor: {
      type: String,
      default: 'error',
    },
    actionIcon: {
      type: String,
      default: 'delete_forever',
    },
    actionTitle: {
      type: String,
      default: 'Delete',
    },
    name: {
      type: String,
      default: 'Test Review',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'cancel', 'confirm'],
  computed: {
    cardText() {
      if (this.bodyText) {
        return this.bodyText;
      }
      return 'This action cannot be reversed and your review will longer be accessible.';
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
      this.$emit('input', false);
    },
    onConfirm() {
      this.$emit('confirm');
      this.$emit('input', false);
    },
  },
};
</script>
